export default "__VITE_ASSET__By4$snnD__"